import { Injectable } from '@angular/core';
import { BaseToggleService } from '../base-toggle.service';

@Injectable({
  providedIn: 'root',
})
export class CommonToggleService extends BaseToggleService {
  private readonly prefix = 'kwa.wallboxDetails';

  public showM20(): boolean {
    return this.toggleService.checkConditions(`${this.flagsPrefix}.showM20`);
  }

  public isP40(): boolean {
    return this.toggleService.checkConditions(`${this.productTypesPrefix}.isP40`);
  }

  public isM20(): boolean {
    return this.toggleService.checkConditions(`${this.productTypesPrefix}.isM20`);
  }

  public isRest(): boolean {
    return this.toggleService.checkConditions(`${this.connectionTypesPrefix}.isRest`);
  }

  public isMasterOrM20(): boolean {
    return this.toggleService.checkConditions(`${this.commonPrefix}.isMasterOrM20`);
  }

  public supportM20UpdateAdministration(): boolean {
    return this.toggleService.checkConditions(`${this.flagsPrefix}.supportM20UpdateAdministration`);
  }

  public isP30(): boolean {
    return this.toggleService.checkConditions(`${this.productTypesPrefix}.isP30`);
  }

  public isRemote(): boolean {
    return this.toggleService.checkConditions(`${this.commonPrefix}.isRemote`);
  }
}
